module.exports = __webpack_public_path__ + "static/media/GL.41271612.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/GL.svg
// module id = 2158
// module chunks = 7